import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type VhcRecordsRepairPartsProps = {
  id: number;
  userId?: number;
};

export const useVhcRecordsRepairPartsMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.postVhcRecordsPartRequests>>,
      QueryError,
      VhcRecordsRepairPartsProps,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id }: VhcRecordsRepairPartsProps) => {
      return VhcRecordLogService.postVhcRecordsPartRequests(id);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully created!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
